import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoldLight = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5834 19.0834V9.91669",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.75 9.91669H21.8333C24.3646 9.91669 26.4167 11.9687 26.4167 14.5C26.4167 17.0313 24.3646 19.0834 21.8333 19.0834H13.5833",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5833 30.0834V19.0834H22.75C25.7876 19.0834 28.25 21.5458 28.25 24.5834V24.5834C28.25 27.6209 25.7876 30.0834 22.75 30.0834H11.75",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgBoldLight);
export default ForwardRef;
